import { ClientCategory } from '../types/clientCategory';
import { VisibilityPresets } from './visibilityPresets';

const DASHBOARD_VISIBILITY_OVERRIDES = {
  Business_review_report_title: VisibilityPresets.anyWithOnline,
  Performance_summary: VisibilityPresets.flipdishOnlineOnly,
  Ordered_items_report_title: VisibilityPresets.flipdishOnlineOnly,
  Sales_report_title: VisibilityPresets.flipdishOnlineOnly,
  Online_tips_report: VisibilityPresets.flipdishOnlineOnly,
  Campaign_performance_report: VisibilityPresets.anyWithOnline,
  Store_operations_report: VisibilityPresets.onlineOnly,
  Property_operations_report: VisibilityPresets.posOnly,
  Customers_report: VisibilityPresets.anyWithOnline,
  Sales_report_beta: VisibilityPresets.anyWithOnline,
  Weekly_report: VisibilityPresets.anyWithOnline,
} as const;

export function getDashboardVisibility(dashboardName: string) {
  return (
    DASHBOARD_VISIBILITY_OVERRIDES[dashboardName as keyof typeof DASHBOARD_VISIBILITY_OVERRIDES] ??
    VisibilityPresets.rmsRequired
  );
}

export function isDashboardVisibleToCategory(
  dashboardName: string,
  category: ClientCategory
): boolean {
  const visibility = getDashboardVisibility(dashboardName);
  return visibility[category];
}
